export { ModernSlaveryHub } from './lib/feature-modern-slavery-hub'
export { getStaticProps } from './lib/get-static-props'
